<template>
    <div>
        <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="full-width"
        >
            <div v-if="loading" class="loading-container">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                />
            </div>
            <div slot="header" class="header-relative header-flex">
                <strong class="header-title">Edit Office</strong>
                <b-button variant="primary" class="back button align-self-center" @click="done()">
                    Back
                </b-button>
            </div>
            <div>
                <h3 class="section-title">Office</h3>
                <b-row class="align-items-center">
                    <b-col md="3">
                        <eb-select
                            type="text"
                            label="label"
                            placeholder="Select Category"
                            v-model="office.officeType"
                            :options="officeOptions"
                            :selected="office.officeType"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <slot name="name">
                            <c-input
                                inputType="text"
                                inputId="userName"
                                labelText="Office Name"
                                v-model="office.officeName"
                            />
                        </slot>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(p, idx) in office.phone"
                            :key="idx"
                            class="d-flex align-items-center"
                        >
                            <div class="flex-grow-1 pr-2 w-100">
                                <c-tel-input
                                    v-model="p.number"
                                    @validate="(e) => isValidate(e, p)"
                                    :defaultInput="p.number"
                                />
                            </div>
                            <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        p.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickPhoneButton(p, idx)"
                                >
                                    <i
                                        :class="
                                            p.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ p.text }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            label="name"
                            @input="getCountry"
                            :options="countries"
                            placeholder="Country"
                            :selected="office.address.country"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            label="name"
                            @input="getState"
                            :options="states"
                            placeholder="State"
                            :selected="office.address.state"
                        ></eb-select>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(e, idx) in office.email"
                            :key="idx"
                            class="d-flex align-items-center mb-2"
                        >
                            <div class="flex-grow-1 pr-2 w-100">
                                <c-input
                                    inputType="text"
                                    inputId="email"
                                    labelText="Email"
                                    v-model="e.mailId"
                                />
                            </div>
                            <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        e.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickEmailButton(e, idx)"
                                >
                                    <i
                                        :class="
                                            e.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ e.isRemovable ? "minus" : "Add" }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////// -->
                <b-row class="mt-0">
                    <b-col md="3">
                        <eb-select
                            placeholder="City"
                            :options="cities"
                            label="name"
                            @input="getCity"
                            :selected="office.address.city"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            class="zipcode"
                            type="text"
                            inputId="zipcode"
                            v-model="office.address.zip"
                            labelText="Zipcode"
                        />
                    </b-col>
                </b-row>
                <!-- ///////////// -->
                <b-row> </b-row>
            </div>
            <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
            <hr
                class="hr-border-primary mt-4"
                v-if="false"
            />
            <!-- //////////////////////////////////////////////////////////////////////////////// -->
            <div class="mt-4" v-if="false">
                <h3 class="section-title">Bill To</h3>
                <b-row class="align-items-end">
                    <b-col md="3">
                        <eb-select
                            type="text"
                            label="label"
                            placeholder="Select Category"
                            v-model="billTo.officeType"
                            :options="officeOptions"
                            :selected="billTo.officeType"
                        />
                    </b-col>
                    <b-col md="4">
                        <slot name="name">
                            <c-input
                                inputType="text"
                                inputId="userName"
                                labelText="Office Name"
                                v-model="billTo.officeName"
                            />
                        </slot>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(p, idx) in billTo.phone"
                            :key="idx"
                            class="d-flex align-items-center"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-input
                                    v-model="p.number"
                                    @validate="(e) => isValidate(e, p)"
                                    :defaultInput="p.number"
                                />
                            </div>
                            <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        p.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickPhoneButtonBill(p, idx)"
                                >
                                    <i
                                        :class="
                                            p.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ p.isRemovable ? "Remove" : "Add" }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            label="name"
                            @input="getCountryBill"
                            :options="countries"
                            placeholder="Country"
                            :selected="billTo.address.country"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            label="name"
                            @input="getStateBill"
                            :options="states"
                            placeholder="State"
                            :selected="billTo.address.state"
                        ></eb-select>
                    </b-col>
                    <b-col md="5">
                        <div
                            v-for="(e, idx) in billTo.email"
                            :key="idx"
                            class="d-flex align-items-center mb-2"
                        >
                            <div class="flex-grow-1 pr-2">
                                <c-input
                                    inputType="text"
                                    inputId="email"
                                    labelText="Email"
                                    v-model="e.mailId"
                                />
                            </div>
                            <div>
                                <b-button
                                    :class="[
                                        'add button',
                                        e.isRemovable
                                            ? 'btn-danger'
                                            : 'btn-primary',
                                    ]"
                                    size="lg"
                                    @click="onClickEamilButtonBill(e, idx)"
                                >
                                    <i
                                        :class="
                                            e.isRemovable
                                                ? 'fa fa-minus-circle mr-1'
                                                : 'fa fa-plus-circle mr-1'
                                        "
                                    ></i>
                                    {{ e.isRemovable ? "Remove" : "Add" }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- //////////// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            placeholder="City"
                            :options="cities"
                            label="name"
                            @input="getCityBill"
                            :selected="billTo.address.city"
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            type="text"
                            inputId="zipcode"
                            v-model="billTo.address.zip"
                            labelText="Zipcode"
                        />
                    </b-col>
                </b-row>
                <!-- ///////////// -->
            </div>
            <!-- ////////////////////////////////////////////////////////////////////////////// -->
            <hr class="hr-border-primary mt-4" />
            <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
            <div>
                <h3 class="section-title">
                    Authentication
                </h3>
                <b-row class="auth-row">
                    <b-col cols="12" md="3">
                        <c-input
                            v-model="authentication.phone"
                            :defaultInput="authentication.phone"
                        />
                    </b-col>

                    <b-col cols="12" md="4">
                        <c-input
                            inputType="text"
                            inputId="username"
                            labelText="User Name"
                            v-model="authentication.userName"
                        />
                    </b-col>

                    <b-col cols="12" md="4">
                        <c-input
                            inputType="text"
                            inputId="email"
                            labelText="Email"
                            v-model="authentication.email"
                            class="email-input"
                        />
                    </b-col>
                </b-row>

                <!-- ///// -->
                <b-row>
                    <b-col md="3">
                        <eb-select
                            :label="'text'"
                            placeholder="Security Question"
                            :options="securityQuestions"
                            :v-model="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions
                                        .question) ||
                                ''
                            "
                            :selected="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions
                                        .question) ||
                                ''
                            "
                        ></eb-select>
                    </b-col>
                    <b-col md="4">
                        <c-input
                            inputType="text"
                            inputId="sqa"
                            labelText="Security Question Answers"
                            :v-model="
                                (authentication &&
                                    authentication.securityQuestions &&
                                    authentication.securityQuestions.answer) ||
                                ''
                            "
                        />
                    </b-col>
                </b-row>
            </div>
            <div class="text-center mb-3 mt-3">
                <button
                    type="button"
                    class="btn btn-lg btn-success ml-3 w-2"
                    @click.prevent="submitAllData"
                >
                    Update
                </button>
            </div>
        </b-card>
    </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import cInputForm from "@/components/FormElements/CustomInput";
import { getReverseGeoCode } from "@/services/geocode";
import { AtomSpinner } from "epic-spinners";
import Vue from "vue";
export default {
    name: "EditOffice",

    data() {
        return {
            loading: false,
            billTo: {},
            securityQuestions: [
                {
                    text: "what is your mother maiden name",
                    value: "what is your mother maiden name",
                },
                {
                    text: "what is your first school",
                    value: "what is your first school",
                },
                { text: "your first car model", value: "your first car model" },
            ],
            authentication: {},
            organization: {},
            position: {
                lat: 0,
                lng: 0,
            },
            countries: [],
            states: [],
            cities: [],
            tenant: null,
            office: {},
        };
    },
    components: {
        cInput,
        cTelInput,
        ebSelect,
        cInputForm,
        AtomSpinner,
    },
    computed: {
        orgAccessOptions() {
            return [
                {
                    label: "Global",
                    value: "Global",
                },
                {
                    label: "Limited",
                    value: "Limited",
                },
            ];
        },
        orgAccessListOptions() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let tenantList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    if (obj.category === "OFFICE") {
                        let arrayObj = {
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            password: "",
                            ...obj,
                        };
                        tenantList.push(arrayObj);
                    }
                });
                return tenantList;
            } else {
                return [];
            }
        },
        officeOptions() {
            return [
                {
                    label: "Default",
                    value: "DEFAULT",
                },
                {
                    label: "Head Office",
                    value: "HEAD_OFFICE",
                },
                {
                    label: "Regional Office",
                    value: "REGIONAL_OFFICE",
                },
                {
                    label: "Branch Office",
                    value: "BRANCH_OFFICE",
                },
            ];
        },
    },
    methods: {
        done() {
            this.$router.push("/office-management");
        },
        async submitAllData() {
            try {
                const data = await getReverseGeoCode(
                    `${this.office.address.street1},${this.office.address.city},${this.office.address.state},${this.office.address.country}`,
                );
                if (data.data.status === "OK") {
                    this.office.address.location = {
                        coordinates: [
                            data.data.results[0].geometry.location.lat,
                            data.data.results[0].geometry.location.lng,
                        ],
                    };
                }
            } catch (error) {}

            //////////////////////////////////////////////////////////
            try {
                const dataBill = await getReverseGeoCode(
                    `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`,
                );
                if (dataBill.data.status === "OK") {
                    this.billTo.address.location = {
                        coordinates: [
                            dataBill.data.results[0].geometry.location.lat,
                            dataBill.data.results[0].geometry.location.lng,
                        ],
                    };
                }
            } catch (error) {}
            ////////////////////////////////////////////////////////////////////////////////
            const { organization, billTo, office, authentication } = this;
            const authenticationCopy = { ...authentication };
            authenticationCopy.securityQuestions = {
                question: authentication.securityQuestions?.question,
                answer: authentication.securityQuestions?.answer,
            };
            const tenant = this.$store.getters["auth/getUserID"];
            office.officeType = this.office.officeType?.value;
            //delete authenticationCopy.securityQA;
            delete organization.location;
            delete authenticationCopy.password;
            delete organization.orgAccessLevel;
            delete organization.orgAccessList;
            delete organization.state;
            const payload = {
                id: this.$store.getters["partner/GetPartnerData"]._id,
                data: {
                    authentication: authenticationCopy,
                    billTo,
                    office,
                    organization,
                    tenant,
                    agreement: {
                        doc: "test",
                    },
                    category: "OFFICE",
                },
            };
            this.loading = true;
            this.$store
                .dispatch("partner/updatePartner", payload)
                .then((result) => {
                    this.loading = false;
                    this.$swal({
                        title: "Success",
                        text: "Office Edited successfully!",
                        type: "success",
                    });
                    this.$router.push("/office-management");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$swal({
                        title: "Error",
                        text: "Could not Edit office",
                        type: "error",
                    });
                });
            //////////////////////////////////////////////////////////////////////////////
        },
        async onClickPhoneButtonBill(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.billTo.phone.push({
                    country: {
                        dialCode: null,
                        iso2: null,
                        name: null,
                    },
                    number: null,
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "Remove",
                });
            else this.billTo.phone.splice(idx, 1);
        },
        async onClickEmailButtonBill(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.billTo.email.push({
                    mailId: "",
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "Remove",
                });
            else this.billTo.email.splice(idx, 1);
        },
        getCountryBill(payload) {
            this.setState(payload.id);
            this.billTo.address.country = payload.name;
        },
        getStateBill(payload) {
            this.setCity(payload.id);
            this.billTo.address.state = payload.name;
        },
        getCityBill(payload) {
            this.billTo.address.city = payload.name;
        },
        async setPlace(p) {
            let place = await p;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        readLogo(e) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {};
        },
        // upload images to the S3 bucket
        async uploadImage(image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "tenant",
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        this.organization.logo = res.data.fileUrl;
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        changeLevel(event) {
            if (event.value === "Global") {
                this.organization.orgAccessList = null;
            }
        },
        isValidate(e, p) {
            p.country = { ...e.country };
            p.isValid = e.isValid;
        },
        getCountry(payload) {
            this.setState(payload.id);
            this.office.address.country = payload.name;
        },
        getState(payload) {
            this.setCity(payload.id);
            this.office.address.state = payload.name;
        },
        getCity(payload) {
            this.office.address.city = payload.name;
        },
        async setCountry() {
            this.countries = await csc.getAllCountries();
        },
        async setState(id) {
            this.states = await csc.getStatesOfCountry(id);
        },
        async setCity(id) {
            this.cities = await csc.getCitiesOfState(id);
        },
        async onClickEmailButton(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.office.email.push({
                    mailId: "",
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "minus",
                });
            else this.office.email.splice(idx, 1);
        },
        async onClickPhoneButton(item, idx) {
            const { isRemovable } = item;
            if (!isRemovable)
                this.office.phone.push({
                    country: {
                        dialCode: null,
                        iso2: null,
                        name: null,
                    },
                    number: null,
                    type: "5cb701203aa1ea2920089568",
                    isRemovable: true,
                    text: "minus",
                });
            else this.office.phone.splice(idx, 1);
        },
    },
    async mounted() {
        await this.$store.dispatch(
            "partner/fetchOfficerById",
            this.$route.params.officeId,
        );
        this.setCountry();
        // this.$store.dispatch("partner/fetchPartnersList");
        this.office = {
            ...this.$store.getters["partner/GetPartnerData"].office,
        };
        this.office.phone.forEach((p) => {
            if (!p.text) {
                p.text = p.isRemovable ? "Remove" : "Add";
            }
        });
        this.organization =
            this.$store.getters["partner/GetPartnerData"].organization;
        // this.billTo = this.$store.getters["partner/GetPartnerData"].office;

        this.authentication.phone =
            this.$store.getters["partner/GetPartnerData"].authentication.phone;
        this.authentication.email =
            this.$store.getters["partner/GetPartnerData"].authentication.email;
        this.authentication.userName =
            this.$store.getters[
                "partner/GetPartnerData"
            ].authentication.userName;
        this.authentication.securityQuestions =
            this.$store.getters[
                "partner/GetPartnerData"
            ].authentication.securityQuestions;
        this.authentication.password =
            this.$store.getters[
                "partner/GetPartnerData"
            ].authentication.password;

        this.position.lat =
            this.$store.getters[
                "partner/GetPartnerData"
            ].office.address.location.coordinates[1];
        this.position.lng =
            this.$store.getters[
                "partner/GetPartnerData"
            ].office.address.location.coordinates[0];
    },
};
</script>
<style scoped>
[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: var(--primary);
    color: white;
}
[btn-special="primary1"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: #2433d7;
    color: white;
}
.back-btn {
    font-weight: bold;
    float: right;
   
}
.back-btn:hover {
    background-color: #24a07d;
}
.statemargintop {
    margin-top: -15px !important;
}
.streetmargintop {
    margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
    border-radius: 0px !important;
    height: 39px !important;
    border: 1px solid #dee2e6 !important;
}

.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

.custom-file-label {
    border-radius: 0px !important;
    border: 1px solid #dee2e6 !important;
    color: #dee2e6 !important;
}
.sqanswer {
    margin-top: -12px !important;
}
.footer-bottons-class {
    margin-top: 50px;
    text-align: center;
    margin-left: 40%;
}
.header-flex {
    display: flex;
    align-items: center;
    justify-content: space-between; 
    position: relative;
  }



.back.button {
    position: static;  
    background-color: #2d2dee;
    color: white;
    border: 1px solid white;
}

.back.button:hover {
    background-color: #1a1aad;
    color: white;
    border: 1px solid #ffffff;
}

.add.button {
    width: 100px;
    margin-bottom: 15px;
    margin-left: 15px;
}
.add.button {
    width: auto;
    min-width: 110px;
    margin-bottom: 15px;
    white-space: nowrap;
}
.loading-container {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
}

.header-relative {
    position: relative;
}

.header-title {
    font-size: 20px;
}

.section-title {
    color: #2c8ef8;
    margin-bottom: 20px;
}

.hr-border-primary {
    border-top: 1px solid var(--primary);
}

@media (max-width: 576px) {
    .back.button {
        top: -7px;
    }

    .header-title {
        font-size: 16px;
    }

    .section-title {
        font-size: 18px;
        margin-bottom: 15px;
    }
}
</style>
